import { CheckCircle2Icon, XCircleIcon } from "lucide-react";
import { TProfileUpdateSchema } from "./update-profile-form";

type TGetVerifiedProps = Partial<Omit<TProfileUpdateSchema, "socialLinks">> & {
	title?: string;
	linkedin?: string | null;
	categories: number;
	identification?: string;
	location?: string;
	socialLinks?: boolean;
};

const GetVerified = ({
	title,
	profilePicture,
	name,
	bio,
	categories,
	identification,
	location,
	company,
	socialLinks,
}: TGetVerifiedProps) => {
	const items = [
		{
			id: "profile",
			label: "Update your Profile picture",
			isComplete: profilePicture,
		},
		{
			id: "name",
			label: "Add your name",
			isComplete: name,
		},
		{
			id: "bio",
			label: "Add your short bio",
			isComplete: bio,
		},
		{
			id: "category",
			label: "Choose your category",
			isComplete: categories > 0,
		},
		{
			id: "identification",
			label: "What do you identify yourself as?",
			isComplete: identification,
		},
		{
			id: "location",
			label: "Select your region",
			isComplete: location,
		},
		{
			id: "company",
			label: "Choose your company",
			isComplete: company,
		},
		{
			id: "socialLinks",
			label: "Add your social links",
			isComplete: socialLinks,
		},
	];

	return (
		<div className="mt-8 overflow-hidden rounded-lg">
			<div className="bg-brand-primary py-4 text-center font-semibold text-white">{title}</div>

			{items.map((item) => (
				<div
					key={item.id}
					className="flex items-center justify-between border-b bg-gray-50 p-4 last:border-0"
				>
					<span className="text-sm font-medium">{item.label}</span>
					{item.isComplete ? (
						<span>
							<CheckCircle2Icon className="h-6 w-6 fill-white stroke-brand-primary" />
						</span>
					) : (
						<span>
							<XCircleIcon className="h-6 w-6  stroke-red-500" />
						</span>
					)}
				</div>
			))}
		</div>
	);
};

export default GetVerified;
